import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {mapParseList, zNumberToString} from '@brunata-angular/util';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {z} from 'zod';

export const customizedExportSystemSchema = z.object({
    systemNo: zNumberToString,
    buildingName: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    // The super types metered in the system, so the step can narrow the list to the chosen ones
    // client-side without refetching on every toggle.
    meterSuperTypeNos: z.array(zNumberToString),
});

export type CustomizedExportSystem = z.infer<typeof customizedExportSystemSchema>;

@Injectable({providedIn: 'root'})
export class SystemsService {
    private readonly baseUrl = environment.onlineServiceUrl;
    private readonly http = inject(HttpClient);

    // Only systems the user can access and that are in operation: the backend excludes operation
    // status 'U' (requirement 1.i), so a system taken out of operation drops off the list — and,
    // via retainAvailableSystems, off the persisted selection — automatically (requirement 1.ii).
    getAvailableSystems(): Observable<CustomizedExportSystem[]> {
        return this.http
            .get(`${this.baseUrl}/customizedexports/systems`, {withCredentials: true})
            .pipe(mapParseList(customizedExportSystemSchema));
    }
}
